import apiClient from './index';

// Admin API endpoints
const adminApi = {
  // User management
  getUserDetails: async (userId) => {
    const response = await apiClient.get(`/adss/v1/users/${userId}?include_roles=true`);
    return response.data;
  },
  
  // Get a user's roles
  getUserRoles: async (userId) => {
    const response = await apiClient.get(`/adss/v1/users/${userId}/roles`);
    return response.data;
  },

  // Role management
  getRoles: async (skip = 0, limit = 100) => {
    const response = await apiClient.get('/adss/v1/users/roles', {
      params: { skip, limit }
    });
    return response.data;
  },
  
  createRole: async (roleData) => {
    const response = await apiClient.post('/adss/v1/users/roles', roleData);
    return response.data;
  },
  
  getRolePermissions: async (roleId) => {
    try {
      // Add a longer timeout for this specific request
      const response = await apiClient.get(`/adss/v1/users/roles/${roleId}/permissions`, {
        timeout: 30000 // 30 seconds timeout
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching role permissions:', error);
      
      // If the server times out or otherwise doesn't respond properly,
      // return a default structure so the UI can still function
      return {
        id: parseInt(roleId),
        name: "Role",
        description: "Permissions unavailable",
        permissions: {
          schema_permissions: [],
          table_permissions: []
        }
      };
    }
  },
  
  // User-Role assignments
  addUserToRole: async (userId, roleId) => {
    const response = await apiClient.post(`/adss/v1/users/${userId}/roles/${roleId}`);
    return response.data;
  },
  
  removeUserFromRole: async (userId, roleId) => {
    const response = await apiClient.delete(`/adss/v1/users/${userId}/roles/${roleId}`);
    return response.data;
  },
  
  // Permission management
  addSchemaPermission: async (roleId, schemaName, permission) => {
    const response = await apiClient.post(`/adss/v1/users/roles/${roleId}/schema-permissions`, {
      schema_name: schemaName,
      permission
    });
    return response.data;
  },
  
  removeSchemaPermission: async (roleId, schemaName) => {
    const response = await apiClient.delete(
      `/adss/v1/users/roles/${roleId}/schema-permissions/${schemaName}`
    );
    return response.data;
  },
  
  addTablePermission: async (roleId, schemaName, tableName, permission) => {
    const response = await apiClient.post(`/adss/v1/users/roles/${roleId}/table-permissions`, {
      schema_name: schemaName,
      table_name: tableName,
      permission
    });
    return response.data;
  },
  
  removeTablePermission: async (roleId, schemaName, tableName) => {
    const response = await apiClient.delete(
      `/adss/v1/users/roles/${roleId}/table-permissions/${schemaName}/${tableName}`
    );
    return response.data;
  },
  
  // User query history (admin access to any user's queries)
  getUserQueryHistory: async (userId, limit = 50) => {
    const response = await apiClient.get(`/adss/v1/queries/users/${userId}`, {
      params: { limit }
    });
    return response.data;
  },

  // Get all queries from all users (admin only)
  getAllQueries: async (limit = 10) => {
    const response = await apiClient.get(`/adss/v1/queries/all`, {
      params: { limit }
    });
    return response.data;
  },

  // Get query statistics (admin only)
  getQueryStats: async () => {
    const response = await apiClient.get(`/adss/v1/queries/stats`);
    return response.data;
  }
};

export default adminApi;